import { uniqBy } from "lodash";
import hash from "object-hash";
import { ERentioFormField } from "../../components/components/Form";
import { getValue } from "../../redux/form/form.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { shouldShowAdditionalCosts } from "./schema.createPayment.2a";
import { EField } from "./schema.createPayment.types";
import { getBookkeepingSummaryForAdditionalCosts, getRelatedContract, } from "./schema.createPayment.utils";
export var getSchema = function (initialValues, extraData) {
    return function (defaultValues) {
        var _a, _b;
        var contract = getRelatedContract(extraData, defaultValues);
        return {
            required: [],
            properties: (_a = {},
                _a[EField.Header + "19"] = {
                    default: undefined,
                },
                _a[EField.AdditionalCostBookkeepingArray] = {
                    // @ts-ignore
                    default: (function () {
                        var oldValues = getValue(EField.AdditionalCostBookkeepingArray, initialValues, defaultValues);
                        if (oldValues) {
                            return oldValues;
                        }
                        return ((contract === null || contract === void 0 ? void 0 : contract.additionalCosts) || []).map(function (cost) {
                            var _a;
                            return (_a = {},
                                _a[EField.BookkeepingGeneralLedgerAccount] = undefined,
                                _a[EField.BookkeepingCostCenter] = undefined,
                                _a[EField.BookkeepingCostUnit] = undefined,
                                _a.description = cost.description,
                                _a.id = hash(cost),
                                _a);
                        });
                    })(),
                    type: "array",
                    // @ts-ignore
                    showIf: function (formData) {
                        return shouldShowAdditionalCosts(formData, contract);
                    },
                    items: {
                        type: "object",
                        required: [EField.BookkeepingGeneralLedgerAccount],
                        properties: (_b = {},
                            _b[EField.BookkeepingGeneralLedgerAccount] = {
                                minLength: 6,
                                maxLength: 6,
                                // @ts-ignore
                                getOptions: function (formData) {
                                    var _a, _b;
                                    var payeeAccountId = (_a = formData[EField.Payee]) === null || _a === void 0 ? void 0 : _a[0];
                                    var paymentOrderType = formData[EField.TypeRecurring] || formData[EField.TypeOnce];
                                    if (!extraData.generalLedgerAccounts) {
                                        return [];
                                    }
                                    var mapGeneralLedgerAccount = function (x) { return ({
                                        id: x.code,
                                        value: ["".concat(x.code), x.description].join(" - "),
                                    }); };
                                    var result = (_b = extraData.generalLedgerAccounts) === null || _b === void 0 ? void 0 : _b.filter(function (x) {
                                        return (!payeeAccountId || x.accountId === payeeAccountId) &&
                                            x.paymentOrderType === paymentOrderType;
                                    }).map(mapGeneralLedgerAccount);
                                    if (result.length > 0) {
                                        return uniqBy(result, "id");
                                    }
                                    return uniqBy(extraData.generalLedgerAccounts.map(mapGeneralLedgerAccount), "id");
                                },
                            },
                            _b[EField.BookkeepingCostCenter] = {
                                default: getValue(EField.BookkeepingCostCenter, initialValues, defaultValues),
                            },
                            _b[EField.BookkeepingCostUnit] = {
                                default: getValue(EField.BookkeepingCostUnit, initialValues, defaultValues),
                            },
                            _b),
                    },
                    uniqueItems: false,
                },
                _a),
        };
    };
};
export var uiSchema = function (extraData) {
    var _a, _b;
    return (_a = {
            "rentio:title": getLocalizedText("payment.payment_order.bookkeeping.heading.summary"),
            "ui:field": ERentioFormField.Grid,
            grid: {
                row: [
                    {
                        col: {
                            width: 1,
                            children: [EField.Header + "19"],
                        },
                    },
                    {
                        col: {
                            width: 1,
                            children: [EField.AdditionalCostBookkeepingArray],
                        },
                    },
                ],
            }
        },
        _a[EField.Header + "19"] = {
            "ui:field": ERentioFormField.SectionHeader,
            title: getLocalizedText("payment.payment_order.bookkeeping.heading"),
        },
        _a[EField.AdditionalCostBookkeepingArray] = {
            "ui:field": ERentioFormField.Array,
            "ui:options": {
                orderable: false,
                addable: false,
                removable: false,
            },
            title: getLocalizedText("payment.payment_order.bookkeeping.heading"),
            getItemTitle: function (itemData) { return itemData === null || itemData === void 0 ? void 0 : itemData.description; },
            items: (_b = {
                    "ui:field": ERentioFormField.Grid,
                    grid: {
                        row: [
                            {
                                col: {
                                    width: [1, 4 / 12],
                                    children: [EField.BookkeepingGeneralLedgerAccount],
                                },
                            },
                            {
                                col: {
                                    width: [1, 4 / 12],
                                    children: [EField.BookkeepingCostCenter],
                                },
                            },
                            {
                                col: {
                                    width: [1, 4 / 12],
                                    children: [EField.BookkeepingCostUnit],
                                },
                            },
                        ],
                    }
                },
                _b[EField.BookkeepingGeneralLedgerAccount] = {
                    "ui:field": ERentioFormField.DropdownSelect,
                    title: getLocalizedText("payment.payment_order.bookkeeping.general_ledger_account"),
                    optional: false,
                },
                _b[EField.BookkeepingCostCenter] = {
                    "ui:field": ERentioFormField.Text,
                    title: getLocalizedText("payment.payment_order.bookkeeping.cost_center"),
                    optional: true,
                },
                _b[EField.BookkeepingCostUnit] = {
                    "ui:field": ERentioFormField.Text,
                    title: getLocalizedText("payment.payment_order.bookkeeping.cost_unit"),
                    optional: true,
                },
                _b),
            formatSummary: function (formData) {
                return getBookkeepingSummaryForAdditionalCosts(formData);
            },
        },
        _a);
};
